import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "type", "disabled", "value", "className", "style", "children", "size", "checked", "onChange"];
import React, { useState, useMemo } from 'react';
import Button from '@uiw/react-button';

/**
 * Constructs a type by picking all properties from `HTMLInputProps` and then removing `size`.
 * Omit: https://www.typescriptlang.org/docs/handbook/utility-types.html#omittk
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var RadioButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-radio',
      type = 'button',
      disabled = false,
      value = '',
      className,
      style,
      children,
      size = 'small',
      checked: prChecked = false,
      onChange
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var [checked, setChecked] = useState(prChecked);
  var [prevChecked, setPrevChecked] = useState();
  if (prChecked !== prevChecked) {
    setPrevChecked(prChecked);
  }
  useMemo(() => {
    if (prChecked !== prevChecked) {
      setChecked(prChecked);
    }
  }, [prevChecked]);
  var cls = [prefixCls, className, disabled ? 'disabled' : null, size ? prefixCls + "-" + size : null].filter(Boolean).join(' ').trim();
  useMemo(() => {
    if (checked !== props.checked) {
      setChecked(!!props.checked);
    }
  }, [props.checked]);
  console.log('props.checked', props.checked);
  function handleChange(e) {
    e.persist();
    if (!checked) {
      setChecked(!checked);
      onChange && onChange(value);
    }
  }
  var label = children || value;
  return /*#__PURE__*/_jsx(Button, _extends({}, _extends({}, other, {
    className: cls,
    style,
    disabled,
    value
  }), {
    type: checked ? 'primary' : 'light',
    ref: ref,
    onClick: handleChange,
    children: label
  }));
});
export default RadioButton;